'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.BlueprintPropTypes = undefined;

var _assign = require('babel-runtime/core-js/object/assign');

var _assign2 = _interopRequireDefault(_assign);

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2; /* eslint-disable react/no-array-index-key */


var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactRouter = require('react-router');

var _chunk = require('lodash/chunk');

var _chunk2 = _interopRequireDefault(_chunk);

var _escapeRegExp = require('lodash/escapeRegExp');

var _escapeRegExp2 = _interopRequireDefault(_escapeRegExp);

var _capitalize = require('lodash/capitalize');

var _capitalize2 = _interopRequireDefault(_capitalize);

var _immutabilityHelper = require('immutability-helper');

var _immutabilityHelper2 = _interopRequireDefault(_immutabilityHelper);

var _antd = require('@adparlor-devops/antd');

var _generic = require('../../helpers/generic');

require('./Blueprint.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Search = _antd.Input.Search;
var FormItem = _antd.Form.Item;

var BlueprintPropTypes = exports.BlueprintPropTypes = {
  admin: _propTypes2.default.bool.isRequired,
  fetchAccounts: _propTypes2.default.func,
  onDelete: _propTypes2.default.func,
  onUpload: _propTypes2.default.func,
  onDuplicate: _propTypes2.default.func,
  form: _propTypes2.default.shape({
    getFieldValue: _propTypes2.default.func.isRequired,
    getFieldDecorator: _propTypes2.default.func.isRequired,
    getFieldError: _propTypes2.default.func.isRequired,
    setFieldsValue: _propTypes2.default.func.isRequired,
    setFieldsInitialValue: _propTypes2.default.func.isRequired,
    isFieldsTouched: _propTypes2.default.func.isRequired,
    validateFields: _propTypes2.default.func.isRequired,
    resetFields: _propTypes2.default.func.isRequired
  }).isRequired,
  blueprints: _propTypes2.default.arrayOf(_propTypes2.default.shape({
    id: _propTypes2.default.string.isRequired,
    previewUrl: _propTypes2.default.string,
    name: _propTypes2.default.string.isRequired,
    description: _propTypes2.default.string
  })).isRequired,
  accounts: _propTypes2.default.shape({
    loading: _propTypes2.default.bool,
    data: _propTypes2.default.arrayOf(_propTypes2.default.shape({}))
  }),
  mediaFBActionUrl: _propTypes2.default.string,
  WSSEToken: _propTypes2.default.string,
  uploadingMediaToFB: _propTypes2.default.bool
};

var Blueprint = (_dec = _antd.Form.create(), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(Blueprint, _Component);

  function Blueprint() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, Blueprint);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = Blueprint.__proto__ || (0, _getPrototypeOf2.default)(Blueprint)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      blueprints: [],
      modalVisible: false,
      accounts: {
        loading: false,
        data: []
      },
      mediaType: "IMAGE",
      fileList: [],
      uploading: false
    }, _this.filterBlueprint = function (searchValue) {
      if (searchValue !== '') {
        var blueprints = _this.props.blueprints;

        var reg = new RegExp((0, _escapeRegExp2.default)(searchValue), 'gi');
        var updatedRuleset = blueprints.map(function (record) {
          var match = record.name.match(reg);
          if (!match) return null;
          return record;
        }).filter(function (record) {
          return !!record;
        });
        _this.setState({
          blueprints: (0, _immutabilityHelper2.default)({}, { $set: updatedRuleset })
        });
      } else {
        _this.setState({
          blueprints: _this.props.blueprints
        });
      }
    }, _this.deleteBlueprint = function (id) {
      if (_this.props.onDelete) {
        _this.props.onDelete(id);
      }
    }, _this.onDuplicate = function (id) {
      if (_this.props.onDuplicate) {
        _this.props.onDuplicate(id);
      }
    }, _this.buildBlueprints = function () {
      var admin = _this.props.admin;
      var blueprints = _this.state.blueprints;

      var columns = blueprints.map(function (blueprint) {
        return _react2.default.createElement(
          _antd.Col,
          { span: 8, key: blueprint.id },
          _react2.default.createElement(
            _reactRouter.Link,
            { to: '/creative_at_scale/generate/' + blueprint.id },
            _react2.default.createElement(
              _antd.Card,
              { className: 'card', bodyStyle: { padding: 0 } },
              _react2.default.createElement(
                'div',
                { className: 'custom-image' },
                _react2.default.createElement('img', { alt: 'example', width: '100%', src: blueprint.previewUrl })
              ),
              _react2.default.createElement(
                'div',
                { className: 'custom-card' },
                _react2.default.createElement(
                  'div',
                  { className: 'custom-card-info' },
                  _react2.default.createElement(
                    'h3',
                    null,
                    blueprint.name
                  ),
                  _react2.default.createElement(
                    'p',
                    null,
                    (0, _capitalize2.default)(blueprint.type),
                    ' Blueprint'
                  )
                ),
                admin && _react2.default.createElement(
                  'div',
                  { className: 'custom-card-actions' },
                  _react2.default.createElement(
                    _antd.Tooltip,
                    { title: 'Duplicate Blueprint', placement: 'top' },
                    _react2.default.createElement(
                      _antd.Popconfirm,
                      {
                        title: 'Duplicate this Blueprint?',
                        onConfirm: function onConfirm() {
                          return _this.onDuplicate(blueprint.id);
                        }
                      },
                      _react2.default.createElement(_antd.Icon, { type: 'copy' })
                    )
                  ),
                  _react2.default.createElement(
                    _antd.Tooltip,
                    { title: 'Edit Blueprint' },
                    _react2.default.createElement(
                      _reactRouter.Link,
                      { to: '/creative_at_scale/create_blueprint/' + blueprint.id },
                      _react2.default.createElement(_antd.Icon, { type: 'edit' })
                    )
                  ),
                  _react2.default.createElement(
                    _antd.Tooltip,
                    { title: 'Delete Blueprint', placement: 'right' },
                    _react2.default.createElement(
                      _antd.Popconfirm,
                      {
                        title: 'Delete this Blueprint?',
                        onConfirm: function onConfirm() {
                          return _this.deleteBlueprint(blueprint.id);
                        }
                      },
                      _react2.default.createElement(_antd.Icon, { type: 'delete' })
                    )
                  )
                )
              )
            )
          )
        );
      });

      var rows = (0, _chunk2.default)(columns, 3);

      return _react2.default.createElement(
        'div',
        null,
        rows.map(function (row, index) {
          return _react2.default.createElement(
            _antd.Row,
            { gutter: 16, key: index },
            [].concat((0, _toConsumableArray3.default)(row))
          );
        })
      );
    }, _this.handleMediaTypeChange = function (_ref2) {
      var target = _ref2.target;

      _this.setState({
        mediaType: target.value,
        fileList: []
      });
    }, _this.handleMediaChange = function (_ref3) {
      var fileList = _ref3.fileList;

      _this.setState({
        fileList: fileList,
        uploading: fileList.filter(function (file) {
          return file.status === "uploading";
        }).length > 0
      });
    }, _this.normFile = function (e) {
      if (Array.isArray(e)) {
        return e;
      }
      return e && e.fileList;
    }, _this.onUpload = function () {
      _this.props.form.validateFields(function (err, values) {
        if (!err) {
          _this.props.onUpload(values);
        }
      });
    }, _this.openUploadModal = function () {
      _this.props.fetchAccounts();
      _this.toggleModalVisible();
    }, _this.toggleModalVisible = function () {
      _this.setState(function (prevState) {
        return {
          modalVisible: !prevState.modalVisible,
          fileList: []
        };
      });
      _this.props.form.resetFields();
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(Blueprint, [{
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(_ref4) {
      var blueprints = _ref4.blueprints,
          uploadingMediaToFB = _ref4.uploadingMediaToFB;

      this.setState((0, _assign2.default)({
        blueprints: blueprints
      }, this.props.uploadingMediaToFB && !uploadingMediaToFB ? { modalVisible: false } : null));
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var getFieldDecorator = this.props.form.getFieldDecorator;
      var _props = this.props,
          mediaFBActionUrl = _props.mediaFBActionUrl,
          WSSEToken = _props.WSSEToken,
          uploadingMediaToFB = _props.uploadingMediaToFB;
      var _state = this.state,
          fileList = _state.fileList,
          mediaType = _state.mediaType,
          uploading = _state.uploading;


      return _react2.default.createElement(
        'div',
        { className: 'Blueprint__Component' },
        _react2.default.createElement(
          _antd.Row,
          null,
          _react2.default.createElement(
            'div',
            { className: 'blueprint-search' },
            _react2.default.createElement(Search, {
              placeholder: 'Search Blueprints',
              style: { width: 200 },
              onChange: function onChange(e) {
                return _this2.filterBlueprint(e.target.value);
              }
            })
          ),
          _react2.default.createElement(
            _antd.Button,
            { className: 'upload-to-fb-button', type: 'primary', onClick: this.openUploadModal },
            'Upload to Facebook'
          )
        ),
        this.buildBlueprints(),
        _react2.default.createElement(
          _antd.Modal,
          {
            title: 'Upload to Facebook',
            visible: this.state.modalVisible,
            closable: true,
            onCancel: uploadingMediaToFB ? null : this.toggleModalVisible,
            width: 700,
            wrapClassName: 'UploadToFB__Modal',
            footer: [_react2.default.createElement(
              _antd.Button,
              { disabled: uploadingMediaToFB, key: 'cancel', onClick: this.toggleModalVisible },
              'Cancel'
            ), _react2.default.createElement(
              _antd.Button,
              { disabled: uploading, loading: uploadingMediaToFB, key: 'upload', onClick: this.onUpload, type: 'primary' },
              'Upload'
            )]
          },
          _react2.default.createElement(
            _antd.Form,
            { layout: 'vertical' },
            _react2.default.createElement(
              _antd.Row,
              { gutter: 24 },
              _react2.default.createElement(
                _antd.Col,
                { span: 12 },
                _react2.default.createElement(
                  FormItem,
                  {
                    label: 'Media Type'
                  },
                  getFieldDecorator('mediaType', {
                    initialValue: 'IMAGE'
                  })(_react2.default.createElement(
                    _antd.Radio.Group,
                    { onChange: this.handleMediaTypeChange },
                    _react2.default.createElement(
                      _antd.Radio.Button,
                      { value: 'IMAGE' },
                      'Image'
                    ),
                    _react2.default.createElement(
                      _antd.Radio.Button,
                      { value: 'VIDEO' },
                      'Video'
                    )
                  ))
                ),
                _react2.default.createElement(
                  FormItem,
                  {
                    label: 'Account ID'
                  },
                  _react2.default.createElement(
                    _antd.Spin,
                    { spinning: this.props.accounts.loading },
                    getFieldDecorator('account_id', {
                      rules: [{ required: true, message: 'Account ID is a required Field' }]
                    })(_react2.default.createElement(
                      _antd.Select,
                      {
                        placeholder: 'Select an account',
                        showSearch: true,
                        style: { width: '100%' },
                        optionFilterProp: 'children',
                        filterOption: function filterOption(input, option) {
                          return option.props.searchValue.toLowerCase().indexOf(input.toLowerCase()) >= 0;
                        },
                        notFoundContent: 'Not Found'
                      },
                      this.props.accounts.data.map(function (account) {
                        return _react2.default.createElement(
                          _antd.Select.Option,
                          { searchValue: account.name, key: account.name, value: '' + account.account_id },
                          account.name || account.account_id
                        );
                      })
                    ))
                  )
                )
              ),
              _react2.default.createElement(
                _antd.Col,
                { span: 12 },
                _react2.default.createElement(
                  FormItem,
                  {
                    label: 'Media',
                    style: { marginBottom: 0 }
                  },
                  getFieldDecorator('media', {
                    getValueFromEvent: this.normFile,
                    rules: [{ required: true, message: 'Media is a required Field' }]
                  })(_react2.default.createElement(
                    _antd.Upload,
                    {
                      accept: (0, _generic.determineAcceptedAttributes)(mediaType),
                      action: mediaFBActionUrl,
                      customRequest: function customRequest(options) {
                        return (0, _generic.upload)(options, WSSEToken);
                      },
                      name: 'mediaFiles',
                      fileList: fileList,
                      onChange: this.handleMediaChange,
                      multiple: true
                    },
                    _react2.default.createElement(
                      _antd.Button,
                      { type: 'dashed', className: 'add-media-button' },
                      _react2.default.createElement(_antd.Icon, { type: 'upload' }),
                      ' Upload Media'
                    )
                  ))
                )
              )
            )
          )
        )
      );
    }
  }]);
  return Blueprint;
}(_react.Component), _class2.propTypes = BlueprintPropTypes, _class2.defaultProps = {
  fetchAccounts: function fetchAccounts() {},
  onDelete: function onDelete() {},
  onUpload: function onUpload() {},
  onDuplicate: function onDuplicate() {},
  accounts: [],
  mediaFBActionUrl: '',
  WSSEToken: '',
  uploadingMediaToFB: false
}, _temp2)) || _class);
exports.default = Blueprint;


//////////////////
// WEBPACK FOOTER
// ./~/@adparlor-devops/ms-paint/lib/components/Blueprint/index.js
// module id = 3891
// module chunks = 5 6 7 8